import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Link } from 'newComponents'
import './styles.scss'

const TaglineTitleCols = (props) => {
  const { data } = props
  const { primary, items } = data
  const { title, tagline } = primary

  // content checks
  const titleHtml = title?.html
  const taglineHtml = tagline?.html

  return (
    <OnVisible className="tagline-title-cols">
      <Section>
        {/* TITLE TAGLINE */}
        {taglineHtml && (
          <div className="tagline-title-cols-tagline" dangerouslySetInnerHTML={{ __html: taglineHtml }} />
        )}
        {titleHtml && <div className="tagline-title-cols-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {/* COLUMNS */}
        <div className="tagline-title-cols-grid">
          {items.map((item) => {
            const { content, title: colTitle, cta_text: linkText, cta_link: linkUrl } = item
            const colTitleHtml = colTitle?.html
            const contentHtml = content?.html
            const contentText = content?.text
            const hasLink = linkUrl?.url && linkText?.text
            return (
              <Link to={linkUrl?.url} className="tagline-title-cols-card" key={contentText.slice(0, 40)}>
                {colTitleHtml && (
                  <div className="tagline-title-cols-card-title" dangerouslySetInnerHTML={{ __html: colTitleHtml }} />
                )}
                {contentHtml && (
                  <div className="tagline-title-cols-card-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />
                )}
                {hasLink && (
                  <Link className="tagline-title-cols-link" withChevron>
                    <span className="tagline-title-cols-link-text">{linkText.text}</span>
                  </Link>
                )}
              </Link>
            )
          })}
        </div>
      </Section>
    </OnVisible>
  )
}

export default TaglineTitleCols
